<template>
  <q-chip
    square
    :color="color"
    :text-color="textColor"
    :label="label"
  />
</template>

<script>

export default {
  name: 'OrderItemTypeCell',
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderItem () {
      return this.props.row
    },
    label () {
      if (this.orderItem.type === 'custom' && this.orderItem.subtype) {
        return _.startCase(this.orderItem.subtype)
      }
      return this.orderItem.type ? _.startCase(this.orderItem.type) : '<unknown>'
    },
    color () {
      if (this.orderItem.state === 'draft') {
        return 'grey-4'
      }
      if (this.orderItem.state === 'voided') {
        return 'red-3'
      }

      if (this.orderItem.type === 'ticket') {
        return 'indigo-3'
      } else if (this.orderItem.type === 'item') {
        return 'green-3'
      } else if (this.orderItem.type === 'membership-interval') {
        return 'blue-grey-3'
      } else if (this.orderItem.type === 'day-pass') {
        return 'blue-grey-3'
      } else if (this.orderItem.type === 'cash') {
        return 'green-8'
      } else if (this.orderItem.type === 'credit') {
        return 'positive'
      } else {
        return null
      }
    },
    textColor () {
      if (this.orderItem.type === 'ticket') {
        return 'dark'
      } else if (this.orderItem.type === 'item') {
        return 'dark'
      } else if (this.orderItem.type === 'cash') {
        return 'white'
      } else if (this.orderItem.type === 'credit') {
        return 'white'
      } else {
        return 'dark'
      }
    }
  }
}

</script>
